import { render, staticRenderFns } from "./Astudy.vue?vue&type=template&id=f2e8732a&scoped=true"
import script from "./Astudy.vue?vue&type=script&lang=js"
export * from "./Astudy.vue?vue&type=script&lang=js"
import style0 from "./Astudy.vue?vue&type=style&index=0&id=f2e8732a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e8732a",
  null
  
)

export default component.exports